import Footer from '../includes/Footer';
/**
 * The base model of a class.
 *
 * @copyright Swoo Inc
 * @website http://swoo.ca
 * @author Jonathan Simard <jonathan@swoo.ca>
 */
export default class Base{

    
    constructor(id,view){

        this.lang = document.documentElement.getAttribute('lang');

        this.menuExpand = document.querySelector('.menu-expand');
        this.menuBt = document.querySelector('.menu_bt');
        this.closMenuBt = document.querySelector('.menu_bt_close');
        this.modal = document.querySelector('.modal');

        this.closeMenu = this.closeMenu.bind(this);
        this.openMenu = this.openMenu.bind(this);
        this.menuBt.addEventListener("click", this.openMenu.bind(this));
        this.closMenuBt.addEventListener("click", this.closeMenu);
        this.modal.addEventListener("click", this.closeMenu);

        this.init(id,view, this.lang);
        this.footer = new Footer(document.querySelector('footer.main'), this.lang);

    }
    
    init(id,view,lang){

        console.log('Base :: init');

    }

    onKeyDown(e){
        if(e.keyCode == 27 && this.modal.classList.contains('active')){
            document.body.classList.remove('frozenScroll');
            this.modal.classList.remove('active');

            if(document.querySelector('.activeLightbox'))
                document.querySelector('.activeLightbox').classList.remove('activeLightbox');

            window.removeEventListener('keydown', this.onKeyDown);
        }
    }

    openMenu(){

        document.body.classList.add('frozenScroll');
        this.modal.classList.add('active');
        this.menuExpand.classList.add('activeLightbox');
        window.addEventListener('keydown', this.onKeyDown.bind(this));

    }
    
    closeMenu(e,mobileMenuOpen = false){
        this.modal.classList.remove('active');
        document.body.classList.remove('frozenScroll');
        
        if(document.querySelector('.activeLightbox'))
            document.querySelector('.activeLightbox').classList.remove('activeLightbox');
        
    }

}
